import {Api} from "@/services/api";
import NavDrawer from "@/views/admin_components/NavDrawer/NavDrawer.vue";
import AppBar from "@/views/admin_components/AppBar/AppBar.vue";

export default {
    name: 'Admins',
    components: {AppBar, NavDrawer},
    data: () => ({
        admins: [],
    }),
    async created() {
        this.admins = await Api.get('admin/getAdmins')
    }
}